
































































import { SfLoader } from "@storefront-ui/vue";
import useCheckOrder from "~/modules/pageExten/composables/useCheckOrder";
import { useUiNotification } from "~/composables";
import OrderDetail from "~/components/checkingOrder/OrderDetail.vue";
import { useClevertapStore } from "~/stores/clevertap";
import {
  defineComponent,
  ref,
  watch,
  computed,
  useRouter,
  useRoute,
  onMounted
} from "@nuxtjs/composition-api";

export default defineComponent({
  name: "CheckOrder",
  components: {
    OrderDetail,
  },

  setup() {
    const { isOrder, loading, error, orderSearchDetail } = useCheckOrder();
    const { send: sendNotification } = useUiNotification();
    const router = useRouter();
    const route = useRoute();
    const clevertapStore = useClevertapStore();

    const orderNumber = ref("");
    const phoneNumber = ref("");
    const orderDetail = ref(null);
    const isViewDetail = ref(false);
    const isCheckPhone = ref(true);
    const phoneRegex = /([0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
    const isCheckSubmit = computed(
      () =>
        phoneRegex.test(phoneNumber.value.trim()) &&
        orderNumber.value.trim() !== ""
    );

    // Function to determine tracking position
    const getTrackingPosition = () => {
      return route.value.path;
    };

    // Function to track order tracking events
    const trackOrderTracking = (orderNumber: string, phoneNumber: string) => {
      if (!process.client) return;
      
      try {
        const win = window as any;
        if (!win.clevertap) return;
        
        // Prepare tracking data
        const trackingData = {
          order_id: orderNumber,
          phone_number: phoneNumber.replace(/^0/, ''), // Remove leading zero if present
          position: getTrackingPosition()
        };
        
        // Send event to CleverTap
        clevertapStore.trackingOrderCleverTap({
          clevertap: win.clevertap,
          data: trackingData
        });
      } catch (error) {
        console.error('Error tracking order tracking:', error);
      }
    };

    watch(phoneNumber, (newVal) => {
      return (isCheckPhone.value = phoneRegex.test(newVal.trim()));
    });

    const checkingOrder = async () => {
      const params = {
        increment_id: orderNumber.value,
        phone_number: phoneNumber.value,
      };

      // Track the order tracking attempt before making the API call
      trackOrderTracking(orderNumber.value, phoneNumber.value);

      orderDetail.value = await orderSearchDetail(params);

      if (!isOrder.value) {
        isViewDetail.value = false;
        sendNotification({
          id: Symbol("order_check_error"),
          message: "order khong ton tai",
          type: "danger",
          icon: "",
          persist: false,
          title: "Verify otp",
        });
      } else {
        isViewDetail.value = true;
      }
    };

    // Check for pre-filled values from URL params
    onMounted(() => {
      if (route.value.query.order_id) {
        orderNumber.value = route.value.query.order_id as string;
      }
      
      if (route.value.query.phone) {
        phoneNumber.value = route.value.query.phone as string;
      }
      
      // If both values are pre-filled, auto-submit the form
      if (orderNumber.value && phoneNumber.value && isCheckSubmit.value) {
        checkingOrder();
      }
    });

    const goBack = () => {
      if (isViewDetail.value) {
        isViewDetail.value = false;
        return;
      }

      1 < window.history.length ? router.go(-1) : router.push("/");
      isViewDetail.value = false;
    };

    return {
      orderNumber,
      phoneNumber,
      isCheckSubmit,
      checkingOrder,
      orderDetail,
      isOrder,
      loading,
      isViewDetail,
      goBack,
      isCheckPhone,
      trackOrderTracking,
    };
  },
});
